/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CargCsclPrgsInfoQryVo
 */
export interface CargCsclPrgsInfoQryVo {
    /**
     * 
     * @type {string}
     * @memberof CargCsclPrgsInfoQryVo
     */
    csclPrgsStts?: string;
    /**
     * 
     * @type {string}
     * @memberof CargCsclPrgsInfoQryVo
     */
    vydf?: string;
    /**
     * 
     * @type {string}
     * @memberof CargCsclPrgsInfoQryVo
     */
    rlseDtyPridPassTpcd?: string;
    /**
     * 
     * @type {string}
     * @memberof CargCsclPrgsInfoQryVo
     */
    prnm?: string;
    /**
     * 
     * @type {string}
     * @memberof CargCsclPrgsInfoQryVo
     */
    ldprCd?: string;
    /**
     * 
     * @type {string}
     * @memberof CargCsclPrgsInfoQryVo
     */
    shipNat?: string;
    /**
     * 
     * @type {string}
     * @memberof CargCsclPrgsInfoQryVo
     */
    blPt?: string;
    /**
     * 
     * @type {string}
     * @memberof CargCsclPrgsInfoQryVo
     */
    dsprNm?: string;
    /**
     * 
     * @type {string}
     * @memberof CargCsclPrgsInfoQryVo
     */
    etprDt?: string;
    /**
     * 
     * @type {string}
     * @memberof CargCsclPrgsInfoQryVo
     */
    prgsStCd?: string;
    /**
     * 
     * @type {string}
     * @memberof CargCsclPrgsInfoQryVo
     */
    msrm?: string;
    /**
     * 
     * @type {string}
     * @memberof CargCsclPrgsInfoQryVo
     */
    wghtUt?: string;
    /**
     * 
     * @type {string}
     * @memberof CargCsclPrgsInfoQryVo
     */
    dsprCd?: string;
    /**
     * 
     * @type {string}
     * @memberof CargCsclPrgsInfoQryVo
     */
    cntrGcnt?: string;
    /**
     * 
     * @type {string}
     * @memberof CargCsclPrgsInfoQryVo
     */
    cargTp?: string;
    /**
     * 
     * @type {string}
     * @memberof CargCsclPrgsInfoQryVo
     */
    shcoFlcoSgn?: string;
    /**
     * 
     * @type {string}
     * @memberof CargCsclPrgsInfoQryVo
     */
    pckGcnt?: string;
    /**
     * 
     * @type {string}
     * @memberof CargCsclPrgsInfoQryVo
     */
    etprCstm?: string;
    /**
     * 
     * @type {string}
     * @memberof CargCsclPrgsInfoQryVo
     */
    shipNm?: string;
    /**
     * 
     * @type {string}
     * @memberof CargCsclPrgsInfoQryVo
     */
    hblNo?: string;
    /**
     * 
     * @type {string}
     * @memberof CargCsclPrgsInfoQryVo
     */
    prcsDttm?: string;
    /**
     * 
     * @type {string}
     * @memberof CargCsclPrgsInfoQryVo
     */
    frwrSgn?: string;
    /**
     * 
     * @type {string}
     * @memberof CargCsclPrgsInfoQryVo
     */
    spcnCargCd?: string;
    /**
     * 
     * @type {string}
     * @memberof CargCsclPrgsInfoQryVo
     */
    ttwg?: string;
    /**
     * 
     * @type {string}
     * @memberof CargCsclPrgsInfoQryVo
     */
    ldprNm?: string;
    /**
     * 
     * @type {string}
     * @memberof CargCsclPrgsInfoQryVo
     */
    dclrDelyAdtxYn?: string;
    /**
     * 
     * @type {string}
     * @memberof CargCsclPrgsInfoQryVo
     */
    mtTrgtCargYnNm?: string;
    /**
     * 
     * @type {string}
     * @memberof CargCsclPrgsInfoQryVo
     */
    cargMtNo?: string;
    /**
     * 
     * @type {string}
     * @memberof CargCsclPrgsInfoQryVo
     */
    cntrNo?: string;
    /**
     * 
     * @type {string}
     * @memberof CargCsclPrgsInfoQryVo
     */
    mblNo?: string;
    /**
     * 
     * @type {string}
     * @memberof CargCsclPrgsInfoQryVo
     */
    blPtNm?: string;
    /**
     * 
     * @type {string}
     * @memberof CargCsclPrgsInfoQryVo
     */
    lodCntyCd?: string;
    /**
     * 
     * @type {string}
     * @memberof CargCsclPrgsInfoQryVo
     */
    prgsStts?: string;
    /**
     * 
     * @type {string}
     * @memberof CargCsclPrgsInfoQryVo
     */
    shcoFlco?: string;
    /**
     * 
     * @type {string}
     * @memberof CargCsclPrgsInfoQryVo
     */
    pckUt?: string;
    /**
     * 
     * @type {string}
     * @memberof CargCsclPrgsInfoQryVo
     */
    shipNatNm?: string;
    /**
     * 
     * @type {string}
     * @memberof CargCsclPrgsInfoQryVo
     */
    agnc?: string;
    /**
     * 
     * @type {string}
     * @memberof CargCsclPrgsInfoQryVo
     */
    frwrEntsConm?: string;
}

/**
 * Check if a given object implements the CargCsclPrgsInfoQryVo interface.
 */
export function instanceOfCargCsclPrgsInfoQryVo(value: object): value is CargCsclPrgsInfoQryVo {
    return true;
}

export function CargCsclPrgsInfoQryVoFromJSON(json: any): CargCsclPrgsInfoQryVo {
    return CargCsclPrgsInfoQryVoFromJSONTyped(json, false);
}

export function CargCsclPrgsInfoQryVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CargCsclPrgsInfoQryVo {
    if (json == null) {
        return json;
    }
    return {
        
        'csclPrgsStts': json['csclPrgsStts'] == null ? undefined : json['csclPrgsStts'],
        'vydf': json['vydf'] == null ? undefined : json['vydf'],
        'rlseDtyPridPassTpcd': json['rlseDtyPridPassTpcd'] == null ? undefined : json['rlseDtyPridPassTpcd'],
        'prnm': json['prnm'] == null ? undefined : json['prnm'],
        'ldprCd': json['ldprCd'] == null ? undefined : json['ldprCd'],
        'shipNat': json['shipNat'] == null ? undefined : json['shipNat'],
        'blPt': json['blPt'] == null ? undefined : json['blPt'],
        'dsprNm': json['dsprNm'] == null ? undefined : json['dsprNm'],
        'etprDt': json['etprDt'] == null ? undefined : json['etprDt'],
        'prgsStCd': json['prgsStCd'] == null ? undefined : json['prgsStCd'],
        'msrm': json['msrm'] == null ? undefined : json['msrm'],
        'wghtUt': json['wghtUt'] == null ? undefined : json['wghtUt'],
        'dsprCd': json['dsprCd'] == null ? undefined : json['dsprCd'],
        'cntrGcnt': json['cntrGcnt'] == null ? undefined : json['cntrGcnt'],
        'cargTp': json['cargTp'] == null ? undefined : json['cargTp'],
        'shcoFlcoSgn': json['shcoFlcoSgn'] == null ? undefined : json['shcoFlcoSgn'],
        'pckGcnt': json['pckGcnt'] == null ? undefined : json['pckGcnt'],
        'etprCstm': json['etprCstm'] == null ? undefined : json['etprCstm'],
        'shipNm': json['shipNm'] == null ? undefined : json['shipNm'],
        'hblNo': json['hblNo'] == null ? undefined : json['hblNo'],
        'prcsDttm': json['prcsDttm'] == null ? undefined : json['prcsDttm'],
        'frwrSgn': json['frwrSgn'] == null ? undefined : json['frwrSgn'],
        'spcnCargCd': json['spcnCargCd'] == null ? undefined : json['spcnCargCd'],
        'ttwg': json['ttwg'] == null ? undefined : json['ttwg'],
        'ldprNm': json['ldprNm'] == null ? undefined : json['ldprNm'],
        'dclrDelyAdtxYn': json['dclrDelyAdtxYn'] == null ? undefined : json['dclrDelyAdtxYn'],
        'mtTrgtCargYnNm': json['mtTrgtCargYnNm'] == null ? undefined : json['mtTrgtCargYnNm'],
        'cargMtNo': json['cargMtNo'] == null ? undefined : json['cargMtNo'],
        'cntrNo': json['cntrNo'] == null ? undefined : json['cntrNo'],
        'mblNo': json['mblNo'] == null ? undefined : json['mblNo'],
        'blPtNm': json['blPtNm'] == null ? undefined : json['blPtNm'],
        'lodCntyCd': json['lodCntyCd'] == null ? undefined : json['lodCntyCd'],
        'prgsStts': json['prgsStts'] == null ? undefined : json['prgsStts'],
        'shcoFlco': json['shcoFlco'] == null ? undefined : json['shcoFlco'],
        'pckUt': json['pckUt'] == null ? undefined : json['pckUt'],
        'shipNatNm': json['shipNatNm'] == null ? undefined : json['shipNatNm'],
        'agnc': json['agnc'] == null ? undefined : json['agnc'],
        'frwrEntsConm': json['frwrEntsConm'] == null ? undefined : json['frwrEntsConm'],
    };
}

export function CargCsclPrgsInfoQryVoToJSON(json: any): CargCsclPrgsInfoQryVo {
    return CargCsclPrgsInfoQryVoToJSONTyped(json, false);
}

export function CargCsclPrgsInfoQryVoToJSONTyped(value?: CargCsclPrgsInfoQryVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'csclPrgsStts': value['csclPrgsStts'],
        'vydf': value['vydf'],
        'rlseDtyPridPassTpcd': value['rlseDtyPridPassTpcd'],
        'prnm': value['prnm'],
        'ldprCd': value['ldprCd'],
        'shipNat': value['shipNat'],
        'blPt': value['blPt'],
        'dsprNm': value['dsprNm'],
        'etprDt': value['etprDt'],
        'prgsStCd': value['prgsStCd'],
        'msrm': value['msrm'],
        'wghtUt': value['wghtUt'],
        'dsprCd': value['dsprCd'],
        'cntrGcnt': value['cntrGcnt'],
        'cargTp': value['cargTp'],
        'shcoFlcoSgn': value['shcoFlcoSgn'],
        'pckGcnt': value['pckGcnt'],
        'etprCstm': value['etprCstm'],
        'shipNm': value['shipNm'],
        'hblNo': value['hblNo'],
        'prcsDttm': value['prcsDttm'],
        'frwrSgn': value['frwrSgn'],
        'spcnCargCd': value['spcnCargCd'],
        'ttwg': value['ttwg'],
        'ldprNm': value['ldprNm'],
        'dclrDelyAdtxYn': value['dclrDelyAdtxYn'],
        'mtTrgtCargYnNm': value['mtTrgtCargYnNm'],
        'cargMtNo': value['cargMtNo'],
        'cntrNo': value['cntrNo'],
        'mblNo': value['mblNo'],
        'blPtNm': value['blPtNm'],
        'lodCntyCd': value['lodCntyCd'],
        'prgsStts': value['prgsStts'],
        'shcoFlco': value['shcoFlco'],
        'pckUt': value['pckUt'],
        'shipNatNm': value['shipNatNm'],
        'agnc': value['agnc'],
        'frwrEntsConm': value['frwrEntsConm'],
    };
}

